<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import Table from '@components/table'
import { loginHistoryComputed, loginHistoryListMethod } from '@state/helpers'

export default {
  page: {
    title: 'Login Histories',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, Table },
  data() {
    return {
      lists: [],
      fields: [
        { key: 'email', title: 'Email', sortable: true, colType: 'default' },
        {
          key: 'ip',
          title: 'IP',
          sortable: true,
          colType: 'default',
        },
        {
          key: 'browser',
          title: 'Browser',
          sortable: true,
          colType: 'default',
        },
        { key: 'action', title: 'Action', sortable: false, colType: 'button' },
      ],
      displayFields: [
        { key: 'email', label: 'Email', colType: 'default' },
        { key: 'ip', label: 'IP', colType: 'default' },
        { key: 'browser', label: 'Browser', colType: 'default' },
        { key: 'createdAt', label: 'Created On', colType: 'date' },
      ],
    }
  },
  computed: {
    ...loginHistoryComputed,
  },
  mounted() {
    const filter = {
      page: this.$route.query.page ? this.$route.query.page : 1,
      limit: 100,
      sort: 'sort_order',
      order: '-1',
    }
    this.fetchLoginHistoryList({ filter })
  },
  methods: {
    ...loginHistoryListMethod,
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <Table
            :items="loginHistoryList.docs ? loginHistoryList.docs : []"
            :fields="fields"
            :bordered="true"
            :viewbtn="true"
            :deletebtn="true"
            :editbtn="false"
            :downloadbtn="true"
            :per-page="loginHistoryList.limit"
            :total-rows="loginHistoryList.totalDocs"
            :current-page="loginHistoryList.page"
            :total-page="loginHistoryList.totalPages"
            :display-fields="displayFields"
            :paging-counter="loginHistoryList.pagingCounter"
          ></Table>
        </b-card>
      </div>
    </div>
  </Layout>
</template>
